import axios from 'axios';
import { default as envConfig } from '@/config/runtimeConfig';

export enum CellularConnectivityQuality {
  GOOD = 'GOOD',
  MEDIUM = 'MEDIUM',
  BAD = 'BAD',
  UNKNOWN = 'UNKNOWN',
}

export enum Installable {
  YES = 'YES',
  NO = 'NO',
  RETRY = 'RETRY',
}

export enum CellularConnectivityResponseType {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}

export enum CellularConnectivityFailureType {
  DEVICE_NOT_FOUND = 'DEVICE_NOT_FOUND',
  NO_MEASUREMENT_DATA = 'NO_MEASUREMENT_DATA',
  GATEWAY_LOOKUP_ERROR = 'GATEWAY_LOOKUP_ERROR',
  OUTDATED_MEASUREMENT_DATA = 'OUTDATED_MEASUREMENT_DATA',
}

export type CellularConnectivitySuccess = {
  type: CellularConnectivityResponseType.SUCCESS;
  quality: CellularConnectivityQuality;
  signalStrength: number | null;
  signalPercent: number | null;
  aesKey: string | null;
  installable: Installable | null; // TODO: remove nullable after PHX-2140 backend is deployed
  timestamp: number | null;
};

export type CellularConnectivityFailure = {
  type: CellularConnectivityResponseType.FAILURE;
  failureType: CellularConnectivityFailureType;
};

export type CellularConnectivityResponse =
  | CellularConnectivitySuccess
  | CellularConnectivityFailure;

export const getLoRaWANCellularConnectivity = async function (
  loRaWanEui: string
): Promise<CellularConnectivityResponse> {
  const { data } = await axios.get<CellularConnectivityResponse>(
    `${envConfig.backendBaseUrl}/connectivity/cellular/lorawan`,
    {
      params: {
        eui: loRaWanEui,
      },
    }
  );
  return data;
};

export const getDMGCellularConnectivity = async function (
  serialNumber: string
): Promise<CellularConnectivityResponse> {
  const { data } = await axios.get<CellularConnectivityResponse>(
    `${envConfig.backendBaseUrl}/connectivity/cellular/dmg`,
    { params: { serialNumber } }
  );
  return data;
};
